import React, { Component } from 'react'
import styled from 'styled-components'
import EtranDocument from './EtranDocument'
import { Input } from 'reactstrap'
import SingleDocumentBucket from '../documents/SingleDocumentBucket'

const EtranResultContainer = styled.div`
  margin: 20px;
`
const BannerContainer = styled.div`
  margin-top: 40px;
  width: 808px;
  border-radius: 4px;
  background-color: ${props => props.isSuccessResponse ? "#F3FAF8" : "#FCF5F3"};
  margin: 10px;
`
const SubmissionStatus = styled.div`
  color: #56565A;
  font-family: "Open Sans";
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  margin-left: 20px;
  padding-top: 10px;
`
const ErrorStatus = styled.div`
  color: #56565A;
  font-family: "Open Sans";
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
  margin-left: 20px;
  padding-top: 10px;
`
const ErrorTitle = styled.h4`
  color: #56565A;
  font-family: "Open Sans";
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
`
const ErrorDetails = styled.ul`
  color: #56565A;
  font-family: "Open Sans";
  font-size: 12px;
  line-height: 14px;
  list-style: none;
  padding: none;
  margin-bottom: 15px;
`
const EtranForm = styled.div`
  margin-top: 40px;
`
const FormRow = styled.div`
  margin-top: 20px;
  display: flex;
`
const FormLabel = styled.label`
  display: inline-flex;
  height: 22px;
  width: 400px;
  color: #56565A;
  font-family: "Open Sans";
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
  cursor: default;
`
const FormInput = styled.input`
  display: inline-flex;
  height: 24px;
  width: 400px;
  color: #56565A;
  font-family: "Open Sans";
  font-size: 14px;
  line-height: 22px;
  background-color: #fff;
  border: 1px solid #ccc;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-sizing: border-box;
  border-radius: 4px;
  width: 395px;
  padding: 4px 6px;
`
const Line = styled.div`
  box-sizing: border-box;
  height: 1px;
  border: 1px solid #DBDBDC;
  margin-top: 30px;
  margin-bottom: 10px;
`
const DatePickerStyled = styled.div`
  /* STYLE FOR WITH */
  .react-datepicker-wrapper {
    width: 395px;
  }
`

const OptionalText = styled.span`
  font-size: 12px;
  color: #99999c;
  margin-left: 5px;
`

export default class EtranResults extends Component {
  constructor(props) {
    super(props)
    this.state = {
      etran_info: props.etranInfo,
      etran_document_file_count: props?.document?.files.length || 0,
    }
  }
  get isSuccessResponse() {
    const { api_response_status } = this.props

    return api_response_status === "success"
  }
  get showBanner() {
    const { api_response_status } = this.props

    return api_response_status === "success" || api_response_status === 'error'
  }
  get isManualProcess() {
    const { etran_process  } = this.props

    return etran_process === 'manual'
  }
  get isSBATypeError() {
    const { errors } = this.props

    return errors[0].status === undefined
  }
  renderBanner = () => {
    const { isSuccessResponse, isManualProcess } = this

    return (
      <BannerContainer isSuccessResponse={isSuccessResponse}>
        { isSuccessResponse &&
          <SubmissionStatus>{isManualProcess ? 'SBA details successfully saved' : 'Loan request was successfully sent to the SBA'}</SubmissionStatus>
        }
        { !isSuccessResponse && this.renderErrorStatus() }
      </BannerContainer>
    )
  }
  renderErrorStatus = () => {
    const { errors } = this.props
    const { isSBATypeError } = this

    return (
      <ErrorStatus>
        <ErrorTitle>There was an error with your loan Submission</ErrorTitle>
        {!isSBATypeError &&
          <ErrorDetails>
            {
              errors.map(({ title, status, detail }) => (<li key={`error-${title}`}>{`${status} - ${detail}`}</li>))
            }
          </ErrorDetails>
        }
        {isSBATypeError &&
          <ErrorDetails>{errors}</ErrorDetails>
        }
      </ErrorStatus>
    )
  }
  validateInputsForSubmit = event => {
    const { target : { name, value } } = event
    const { setSubmitButtonDisabled } = this.props
    const { etran_info } = this.state

    etran_info[name] = value
    this.setState({ etran_info })

    setSubmitButtonDisabled(this.props.validInput(etran_info), etran_info)
  }
  renderFormInput = (name,placeholder, disabled_input, default_value) => {
    return (
      <FormInput
        name={name}
        placeholder={placeholder}
        onKeyDown={this.onKeyDown}
        readOnly={disabled_input}
        defaultValue={default_value}
        maxLength={name === 'plp_authorization_number' ? 12 : undefined}
        onBlur={this.validateInputsForSubmit}/>
    )
  }
  renderFormDatepicker = (name, default_value, disabled_input) => {
    return (
      <DatePickerStyled>
        <Input
          className="react-datepicker-wrapper"
          type="date"
          name={name}
          placeholder="MM/DD/YYYY"
          readOnly={disabled_input}
          defaultValue={ default_value }
          onBlur={this.validateInputsForSubmit}/>
      </DatePickerStyled>
    )
  }
  renderResultsForm = (disabled_input, etran_data) => {
    return (
      <EtranForm>
        <FormRow>
          <FormLabel>E-Tran Score</FormLabel>
          { this.renderFormInput('etran_score', '', disabled_input, etran_data.etran_score)}
        </FormRow>
        <FormRow>
          <FormLabel>E-Tran Score Date</FormLabel>
          { this.renderFormDatepicker("score_date", etran_data.score_date, disabled_input) }
        </FormRow>
        <FormRow>
          <FormLabel>PLP Authorization Number{' '}<OptionalText>(optional)</OptionalText></FormLabel>
          { this.renderFormInput('plp_authorization_number', 'Ex. 4378905002 (do not include -)', disabled_input, etran_data.plp_authorization_number)}
        </FormRow>
        <FormRow>
          <FormLabel>PLP Authorization Date{' '}<OptionalText>(optional)</OptionalText></FormLabel>
          { this.renderFormDatepicker("plp_authorization_date", etran_data.plp_authorization_date, disabled_input) }
        </FormRow>
      </EtranForm>
    )
  }
  renderSuccessResponseResultsForm = () => {
    const { isManualProcess } = this
    const etran_info = isManualProcess? this.state.etranInfo : {
      "etran_score" : "160",
      "plp_authorization_number" : "12345678",
      "plp_authorization_date" : "11/01/2020 03:30 PM PDT",
      "score_date": "11/01/2020 03:30 PM PDT"
    }

    this.renderResultsForm(true, etran_info)
  }
  onKeyDown = e => {
    this.setState({ error: false })
    const { moveFns } = this.props
    const { keyCode, shiftKey, ctrlKey, metaKey } = e
    // Only numbers, spaces, tab, enter, copy, paste, plus, and minus are allowed
    const allowKeyNumbers = [8,9,13,37,38,39,40,46,48,49,50,51,52,53,54,55,56,57,67,76,86,96,97,98,99,100,101,102,103,104,105,187,189]

    if ((e.keyCode === allowKeyNumbers[22] && !shiftKey) || (e.keyCode === allowKeyNumbers[23] && shiftKey)) {
      e.preventDefault()
    } else if (!(allowKeyNumbers.includes(keyCode))) {
      e.preventDefault()
      return false
    } else if (keyCode === allowKeyNumbers[2] && shiftKey) {
      if (moveFns) {
        e.preventDefault() // Cell may not always be used in edit mode, if it is not, don't call move functions
        moveFns.up()
      }
    } else if (keyCode === allowKeyNumbers[2]) {
      if (moveFns) {
        e.preventDefault()
        moveFns.down()
      }
    } else if (keyCode === allowKeyNumbers[1] && shiftKey) {
      if (moveFns) {
        e.preventDefault()
        moveFns.left()
      }
    } else if (keyCode === allowKeyNumbers[1]) {
      if (moveFns) {
        e.preventDefault()
        moveFns.right()
      }
    } else if (keyCode === allowKeyNumbers[6]) {
      if (moveFns) {
        e.preventDefault()
        moveFns.down()
      }
    } else if (keyCode === allowKeyNumbers[4]) {
      if (moveFns) {
        e.preventDefault()
        moveFns.up()
      }
    } else if (keyCode === allowKeyNumbers[20] && !ctrlKey && !metaKey) {
      e.preventDefault()
    } else if (keyCode === allowKeyNumbers[18] && !ctrlKey && !metaKey) {
      e.preventDefault()
    }
  }
  renderEtranDocument = () => {
    const category = "business_bank_search"
    const resourceType = "Business"
    const {
      loanId,
      document,
      entityId,
      setSubmitButtonDisabled,
      etranInfo,
      documentBucketOptions,
    } = this.props

    const {
      updatedStageBasedDocumentsExperienceUi,
      ...restOfDocumentBucketOptions
    } = documentBucketOptions

    if (updatedStageBasedDocumentsExperienceUi)
      return (
        <div style={{ marginTop: '20px' }}>
          <SingleDocumentBucket
            {...restOfDocumentBucketOptions}
            loanId={loanId}
            documentId={document.rid}
            resourceType={resourceType}
          />
        </div>
      )

    return (
      <EtranDocument
        key={`${document.title}-${document.rid}`}
        document={document}
        entityId={entityId}
        category={category}
        loanId={loanId}
        resourceType={resourceType}
        setSubmitButtonDisabled={setSubmitButtonDisabled}
        validInput={this.props.validInput}
        etranInfo={etranInfo}
      />
    )
  }
  renderPPPForm = () => {
    const { etranInfo } = this.props

    return (
      <EtranForm>
        <FormRow>
          <FormLabel>Submission Status</FormLabel>
          { this.renderFormInput('status', '', true, etranInfo.sba_status)}
        </FormRow>
        <FormRow>
          <FormLabel>Unique ID</FormLabel>
          { this.renderFormInput('id', '', true, etranInfo.external_id)}
        </FormRow>
      </EtranForm>
    )
  }
  render() {
    const { showBanner, isSuccessResponse, isManualProcess } = this
    const { etranInfo, is_paycheck_protection, api_response_status } = this.props

    return (
      <EtranResultContainer>
        { showBanner && this.renderBanner() }
        {!is_paycheck_protection &&
          <>
            { isSuccessResponse && !isManualProcess && this.renderSuccessResponseResultsForm() }
            { isManualProcess && this.renderResultsForm(false, etranInfo) }
            { isManualProcess && <Line /> }
            { isManualProcess && this.renderEtranDocument() }
          </>
        }
        {is_paycheck_protection && api_response_status !== 'error' && this.renderPPPForm()}
      </EtranResultContainer>
    )
  }
}
